import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';
import HandWithPhone from './images/Hand-With-Phone.png';
import AppleLogo from './images/apple-logo.png';
import GooglePlayLogo from './images/google-play-logo.png';

const StyledImage = styled('img')(({ theme }) => ({
  width: '16vw',
  maxWidth: '230px',
  position: 'absolute',
  right: '30px',
  bottom: 0,
  minWidth: '130px',

  [`@media screen and (max-width: ${theme.breakpoints.values.md}px)`]: {
    bottom: '-16px',
  },

  [`@media screen and (min-width: 1400px)`]: {
    right: 0,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  padding: '16px 20px',
  backgroundColor: `${theme.palette.common.black}`,
  borderRadius: '12px',

  '&:hover': {
    opacity: '.8',
    backgroundColor: `${theme.palette.common.black}`,
  },
}));

const ButtonIcon = styled('img')(({ theme }) => ({
  height: '45px',
  marginRight: theme.spacing(2),

  [`@media screen and (max-width: 780px)`]: {
    height: '30px',
  },
}));

export default function AboutSection() {
  return (
    <Box sx={{ p: '0!important', height: { md: '230px', sm: 'auto', xs: '300px' } }}>
      <Box sx={{ bgcolor: 'action.selected', height: '100%', p: { lg: '0', md: '0 32px', xs: '16px 32px' } }}>
        <Box
          sx={{
            maxWidth: '1200px',
            position: 'relative',
            margin: '0 auto',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: { xl: '930px', md: '65vw', sm: '70vw', xs: '80vw' },
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: { md: 'center', xs: 'start' },
              flexDirection: { md: 'row', xs: 'column' },
              gap: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: 'ZalandoSans',
                fontWeight: '800',
                fontSize: { lg: '65px', md: '50px', sm: '45px', xs: '50px' },
                lineHeight: 1.2,
                color: 'error.main',
                width: { md: '50%', xs: '100%' },
              }}
            >
              Download VSPi Capture
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              <StyledButton
                variant="contained"
                color="error"
                href="https://apps.apple.com/us/app/vpsi-capture/id6746084350"
                target="_blank"
              >
                <ButtonIcon src={AppleLogo} alt="Apple Logo" />
                <Box>
                  <Typography sx={{ fontSize: '15px', textAlign: 'left', lineHeight: '1' }}>Download on the</Typography>
                  <Typography sx={{ fontSize: { lg: '30px', xs: '20px' }, textAlign: 'left', lineHeight: '1' }}>
                    App Store
                  </Typography>
                </Box>
              </StyledButton>
              <StyledButton
                variant="contained"
                color="error"
                href="https://play.google.com/store/apps/details?id=com.videoplussensors.vpsicapture&pli=1"
                target="_blank"
              >
                <ButtonIcon src={GooglePlayLogo} alt="Google Play Logo" />
                <Box>
                  <Typography sx={{ fontSize: '15px', textAlign: 'left', lineHeight: '1' }}>Download on the</Typography>
                  <Typography sx={{ fontSize: { lg: '30px', xs: '20px' }, textAlign: 'left', lineHeight: '1' }}>
                    Play Store
                  </Typography>
                </Box>
              </StyledButton>
            </Box>
          </Box>
          <StyledImage src={HandWithPhone} alt="Hand with Phone" />
        </Box>
      </Box>
    </Box>
  );
}
